/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from "react";
import * as medicalApi from "../../service/medicalApi";
import moment from "moment";
import "moment/locale/th";

import Pagination from "../pagination/Pagination";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { RedirectCode400 } from "../RedirectCode400";
import { CurrentUserContext } from "../../App";
import styles from "./GuidelineTextEditor.module.css";

import PageHeader from "../pageheader/PageHeader";
import Breadcrumb from "../public/breacrumb/breadcrumb";
import Footer from "../footer/Footer";
import HeadBar from "../../component/public/headBar/HeadBar";
import ModalUploadFileV3 from "../material/modal/ModalUploadFileV3";
import ModalDeleteDocument from "../material/modal/ModalDeleteDocument";
import ModalDeleteGuideline from "../material/modal/ModalDeleteGuideline";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrashCan, faEdit } from "@fortawesome/free-solid-svg-icons";

function DocumentGuide() {
  const { setIsMessage } = useContext(CurrentUserContext);
  const doctor = JSON.parse(localStorage.getItem("user"));
  const [toggle, setToggle] = useState("guide"); // document, guide
  const [documentList, setDocumentList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [openModalUploadFile, setOpenModalUploadFile] = useState(false);
  const [date, setDate] = useState("");

  const [guideList, setGuideList] = useState([]);
  const [guidePage, setGuidePage] = useState(1);
  const [guideMaxPage, setGuideMaxPage] = useState(1);
  const [openModalDeleteDocument, setOpenModalDeleteDocument] = useState(false);
  const [documentData, setDocumentData] = useState({});

  const [openModalDeleteGuideline, setOpenModalDeleteGuideline] =
    useState(false);
  const [guidelineData, setGuidelineData] = useState({});

  const location = useLocation();
  const nav = useNavigate();

  useEffect(() => {
    setDate(moment().add(543, "years").format("D MMMM YYYY"));
    if (location.state?.type) {
      setToggle(location.state?.type);
    }
  }, []);

  useEffect(() => {
    getDocumentList();
  }, [page]);

  useEffect(() => {
    getGuideline();
  }, [guidePage]);

  useEffect(() => {
    if (toggle === "document") {
      getDocumentList();
    } else if (toggle === "guide") {
      getGuideline();
    }
  }, [toggle]);

  const getDocumentList = async () => {
    setLoading(true);
    let res = await medicalApi.getDocument(page, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        //console.log(res["data"]["document_list"]);
        //console.log(doctor)
        setDocumentList(res["data"]["document_list"]);
        setMaxPage(Math.ceil(res["data"]["amount"] / 10));
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: 'res["data"]["message_th"] || res["data"]["message"]',
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const showRemoveDocument = async (item) => {
    setDocumentData(item);
    setOpenModalDeleteDocument(true);
  };

  const removeDocument = async (item) => {
    // if (!window.confirm(`คุณต้องการลบ ${item.document_name} ใช่หรือไม่`)) {
    //     return;
    // }
    setLoading(true);
    let res = await medicalApi.removeDocument(item.document_id);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        setOpenModalDeleteDocument(false);
        getDocumentList();
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: 'res["data"]["message_th"] || res["data"]["message"]',
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
      setDocumentList([]);
    }
  };

  const addDocument = async (event) => {
    let formData = new FormData();
    formData.append("file", event.file);
    formData.append("file_name", event.inputValue);
    setLoading(true);
    let res = await medicalApi.addDocument(formData);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({ type: "success", data: "สำเร็จ" });
        setOpenModalUploadFile(false);
        getDocumentList();
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: 'res["data"]["message_th"] || res["data"]["message"]',
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const getGuideline = async () => {
    setLoading(true);
    let res = await medicalApi.getGuideline(guidePage, 10);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        //console.log(res["data"]);
        setGuideList(res["data"]["guideline_list"]);
        setGuideMaxPage(Math.ceil(res["data"]["amount"] / 10));
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: 'res["data"]["message_th"] || res["data"]["message"]',
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const showRemoveGuideline = async (item) => {
    setGuidelineData(item);
    setOpenModalDeleteGuideline(true);
  };

  const editGuideline = async (item) => {
    nav("/guideline-form", {
      state: {
        ...item,
        type: "edit",
        publishStartDate: item.publish_start_date?.date,
        publishEndDate: item.publish_end_date?.date,
        pined: item.pined,
      },
    });
  };

  const removeGuideline = async (item) => {
    // if (!window.confirm(`คุณต้องการลบ ${item["title"] || "-"} ใช่หรือไม่`)) {
    //     return;
    // }
    setLoading(true);
    let res = await medicalApi.removeGuideline(item["guideline_id"]);
    setLoading(false);
    if (res) {
      if (res["data"]["code"] === 200) {
        getGuideline();
      } else if (res["data"]["code"] === 403) {
        nav(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: 'res["data"]["message_th"] || res["data"]["message"]',
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
    setOpenModalDeleteGuideline(false);
  };

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "แนวทางการตรวจ/เอกสารที่เกี่ยวข้อง", url: "/document-guide" },
  ];

  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />
        <PageHeader titlename="แนวทางการตรวจ/เอกสารที่เกี่ยวข้อง" />

        <div>
          <div className="flex ">
            <button
              type="button"
              className={`${styles.tabsBar}  ${toggle === "guide" ? styles.tabsBarActive : ""}`}
              onClick={() => {
                setToggle("guide");
              }}
            >
              แนวทางการตรวจ
            </button>
            <button
              type="button"
              className={`${styles.tabsBar}  ${toggle === "document" ? styles.tabsBarActive : ""}`}
              onClick={() => {
                setToggle("document");
              }}
            >
              เอกสารที่เกี่ยวข้อง
            </button>
          </div>

          {/* {!loading ? */}
          <div>
            {toggle === "document" ? (
              <>
                <button
                  type="button"
                  className="flex flex-row gap-2 justify-center py-4 px-5 my-4 md:w-auto w-[40%] bg-[#F0F9FF] text-[#233ABE] border-[1px] border-solid border-[#0B88EB] rounded"
                  onClick={() => {
                    setOpenModalUploadFile(true);
                  }}
                >
                  <div>
                    <FontAwesomeIcon icon={faPlus} />
                  </div>
                  <div>เพิ่มไฟล์เอกสาร</div>
                </button>
                <p className="font-bold">เอกสารที่เกี่ยวข้อง</p>
                <p>
                  ท่านสามารถคลิกหรือเพิ่มเอกสารที่เห็นว่าเป็นประโยชน์ต่อบุคลากรทางแพทย์ได้ที่นี่
                </p>
                <p>
                  ทั้งหมด{" "}
                  <span className="text-[#0B88EB]">{documentList.length}</span>{" "}
                  รายการ
                  <span className="text-sm ms-2">(ข้อมูลวันที่ {date})</span>
                </p>
                {documentList.length > 0 ? (
                  <>
                    {documentList?.map((item, index) => (
                      <div
                        key={index}
                        className="flex flex-row items-center w-full border-b-[2px] py-4 "
                      >
                        <div className="w-[80%] md:w-full break-all text-pretty">
                          {item.document_name}
                        </div>
                        <div className="w-[5%] md:w-[50px] md:px-4 flex justify-center">
                          {item?.owner?.uid === doctor?.uid ? (
                            <FontAwesomeIcon
                              icon={faTrashCan}
                              color="#FF0000"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                showRemoveDocument(item);
                              }}
                            />
                          ) : null}
                        </div>
                        <div className="w-[10%] md:w-[100px] md:px-4 flex justify-center">
                          {item.document_file ? (
                            <span
                              className="cursor-pointer hover:text-[#0B88EB]"
                              onClick={() => {
                                window.open(item.document_file);
                              }}
                            >
                              ดาวน์โหลด
                            </span>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    ))}
                  </>
                ) : null}
                {maxPage > 1 ? (
                  <Pagination
                    page={page}
                    totalpage={maxPage}
                    clickForward={() => {
                      if (page < maxPage) {
                        setPage(page + 1);
                      }
                    }}
                    clickBackward={() => {
                      if (page > 1) {
                        setPage(page - 1);
                      }
                    }}
                  />
                ) : null}
              </>
            ) : null}

            {toggle === "guide" ? (
              <>
                <button
                  type="button"
                  className="flex flex-row gap-2 justify-center py-4 px-5 my-4 md:w-auto w-[40%] bg-[#F0F9FF] text-[#233ABE] border-[1px] border-solid border-[#0B88EB] rounded"
                  onClick={() => {
                    nav("/guideline-form", {
                      state: {
                        type: "add",
                      },
                    });
                  }}
                >
                  <div>
                    <FontAwesomeIcon icon={faPlus} />
                  </div>
                  <div>เพิ่มแนวทางการตรวจ</div>
                </button>
                <p className="font-bold">แนวทางการตรวจ</p>
                <p>
                  1.ท่านสามารถถ่ายทอดประสบการณ์การรักษาหรือแนวทางการตรวจแก่บุคลากรทางแพทย์ท่านอื่นๆผ่านทางช่องทางนี้ได้
                </p>
                <p>
                  2.คลิกหัวข้อเพื่ออ่านการถ่ายทอดประสบการณ์จากบุคลากรทางการแพทย์ได้ที่นี่
                </p>
                <p>
                  แนวทางการตรวจแลปทั้งหมด{" "}
                  <span className="text-[#0B88EB]">{guideList.length}</span>{" "}
                  รายการ
                  <span className="text-sm ms-2">(ข้อมูลวันที่ {date})</span>
                </p>
                {guideList.length > 0 ? (
                  <>
                    {guideList?.map((item, index) => (
                      <div
                        key={index}
                        className="flex flex-row items-center w-full border-b-[2px] py-4 "
                      >
                        <div className="w-[95%] md:w-full break-all text-pretty">
                          <Link
                            to={`/document-guide/${item.guideline_id}`}
                            style={{ color: "inherit" }}
                          >
                            {item.title}
                          </Link>
                        </div>
                        <div className="w-[5%] md:w-[50px] md:px-4 flex justify-center">
                          {item?.owner?.uid === doctor?.uid ? (
                            <>
                              <FontAwesomeIcon
                                icon={faEdit}
                                color="#00917e"
                                style={{
                                  cursor: "pointer",
                                  marginRight: "10px",
                                }}
                                onClick={() => {
                                  editGuideline(item);
                                }}
                              />

                              <FontAwesomeIcon
                                icon={faTrashCan}
                                color="#FF0000"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  showRemoveGuideline(item);
                                }}
                              />
                            </>
                          ) : null}
                        </div>
                      </div>
                    ))}
                  </>
                ) : null}
                {guideMaxPage > 1 ? (
                  <Pagination
                    page={guidePage}
                    totalpage={guideMaxPage}
                    clickForward={() => {
                      if (guidePage < guideMaxPage) {
                        setGuidePage(guidePage + 1);
                      }
                    }}
                    clickBackward={() => {
                      if (guidePage > 1) {
                        setGuidePage(guidePage - 1);
                      }
                    }}
                  />
                ) : null}
              </>
            ) : null}
          </div>
          {/* : <HashLoader loading={true} style={{ display: 'flex', justifyContent: 'center', margin: '20px' }} color="#FF9768" /> */}
          {/* } */}
        </div>

        <ModalUploadFileV3
          show={openModalUploadFile}
          title="อัพโหลดไฟล์เอกสาร"
          placeholder="ชื่อเอกสาร"
          titlename="อัพโหลดไฟล์เอกสาร"
          onSubmit={addDocument}
          initialData={null}
          onClose={() => setOpenModalUploadFile(false)}
        />
        {/* <ModalUploadFileV2
                    show={openModalUploadFile}
                    title={"อัพโหลดไฟล์เอกสาร"}
                    placeholder={"ชื่อเอกสาร"}
                    titlename={"อัพโหลดไฟล์เอกสาร"}
                    onSubmit={addDocument}
                    onClose={() => {
                        setOpenModalUploadFile(false);
                    }}
                /> */}

        {openModalDeleteDocument ? (
          <ModalDeleteDocument
            onClose={() => {
              setOpenModalDeleteDocument(false);
            }}
            data={documentData}
            onClickData={(item) => {
              removeDocument(item);
            }}
          />
        ) : null}

        {openModalDeleteGuideline ? (
          <ModalDeleteGuideline
            onClose={() => {
              setOpenModalDeleteGuideline(false);
            }}
            data={guidelineData}
            onClickData={(item) => {
              removeGuideline(item);
            }}
          />
        ) : null}
      </div>
    </>
  );
}

export default DocumentGuide;
